import type { Product } from '../models';

export const getInitialProduct = ({
  initialProductCode,
  products,
}: {
  initialProductCode?: string;
  products: Product[];
}) => {
  if (initialProductCode) {
    const initialProduct = products.find(({ code }) => code === initialProductCode);
    const initialProductShade = initialProduct?.shades.find(({ productCode }) => productCode === initialProductCode);
    const productIndex = products.findIndex(({ code }) => code === initialProductCode);
    const index = productIndex < 0 ? 0 : productIndex;

    return { index, product: initialProduct, shade: initialProductShade };
  }

  return { index: 0, product: products[0], shade: products[0]?.shades?.[0] };
};
